import { List, ListItem, Radio, VStack } from '@chakra-ui/react';
import { PricingPlan } from '@services/appsync/types';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type PricingPlanOptionProps = {
  label: string;
  value: PricingPlan;
  description?: string;
  points: string[];
};

export const PricingPlanOption: React.FC<PricingPlanOptionProps> = ({ label, description, points = [], value }) => {
  return (
    <VStack
      as="label"
      position="relative"
      border="1px solid rgba(0,0,0,0.1)"
      borderRadius="15px"
      cursor="pointer"
      width="full">
      <VStack
        backgroundColor="blue.50"
        w="full"
        gap="0"
        borderTopLeftRadius={'15px'}
        borderTopRightRadius={'15px'}
        padding="20px">
        <Radio position="absolute" top="10px" left="10px" value={value} backgroundColor="white" />
        <TextBlock color="blue.500" weight="bold" fontSize={'21px'} lineHeight={'18px'}>
          {label}
        </TextBlock>
        {description && <TextBlock opacity="0.75">{description}</TextBlock>}
      </VStack>
      <List padding="20px" marginTop="0">
        {points.map((point, index) => (
          <ListItem
            key={index}
            listStylePos="initial"
            listStyleType={'initial'}
            fontSize={'14px'}
            opacity="0.5"
            margin="0 20px">
            {point}
          </ListItem>
        ))}
      </List>
    </VStack>
  );
};
